// Module
var code = "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}} {{scrollable ? 'modal-dialog-scrollable': ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div> ";
// Exports
export default code;